//
//
//
//
//
//
//
//
//
//

export default {
  name: "UiBreadcrumbs",
  props: {
    breadcrumbs: {
      type: Array,
      default() {
        return []
      }
    }
  },
  methods: {
    action(item) {
      if (!item.disabled && item.action) {
        item.action();
      }
    },
  },
}
